import React, { Component } from "react";
import {
  Table,
  Input,
  Grid,
  Button,
  Icon,
  Dropdown,
  Checkbox,
  Label
} from "semantic-ui-react";
import "./timeEntry.css";
import TimeInput from "./timeinput";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { InitialTime } from "../../../actions/initial-time";
import AddJob from "./addjob";
import { jobassign } from "../../../actions/job-assign";
import RemoveJob from "./removejob";
import Swipeable from "react-swipeable";
import moment from "moment";
import jobsort from "../../../services/jobsort";
import { getpath } from "../../../actions/get-path";
import roundy from "../../../services/roundy";
class TimeEntryDesktop extends Component {
  constructor(props) {
    super(props);
    this.state = {
      daystring: "",
      date: moment().format("YYYY-MM-DD"),
      displaydate: null,
      monday: null,
      realtimesheet: [],
      days: ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"],
      myempnumber: null,
      wods: [],
      weekarray: [],
      dayindex: null,
      printable: false,
    };
  }

  genAddJob() {
    return this.props.jobs.map((job) => {
      if (!job.active) {
        return (
          <Dropdown.Item
            text={job.derivative + "-" + job.description}
            onClick={() =>
              this.handleJobAssign(job.derivative, job.description, true)
            }
          />
        );
      }
    });
  }
  genRemoveJob() {
    return this.props.jobs.map((job) => {
      if (job.active) {
        return (
          <Dropdown.Item
            text={job.derivative + "-" + job.description}
            onClick={() =>
              this.handleJobAssign(job.derivative, job.description, false)
            }
          />
        );
      }
    });
  }

  handleJobAssign = (derivative, description, active) => {
    console.log("firing action: job");
    this.props.jobassign(derivative, active);
  };
  genTotalJob(wod) {
    var jobs = this.props.realtimesheet
      .filter((entry) => {
        return entry.workordernumber == wod.assigned_task;
      })
      .map((tjd) => {
        return tjd.hours;
      });

    var sum = 0;
    for (var i = jobs.length; i--;) {
      sum += jobs[i];
    }
    return sum;
  }
  genTotalDay(date) {
    var dayarray = this.props.realtimesheet
      .filter((entry) => {
        return entry.dateperformed === date;
      })
      .map((td) => {
        return td.hours;
      });

    var sum = 0;
    for (var i = dayarray.length; i--;) {
      sum += dayarray[i];
    }

    return sum;
  }
  genTotality() {
    let weekhours = [];
    this.props.realtimesheet.map((entry) => {
      weekhours.push(entry.hours);
    });
    var sum = 0;
    for (var i = weekhours.length; i--;) {
      sum += weekhours[i];
    }
    return sum;
  }

  genRows(dates) {
    if (this.props.wods.length && this.props.jobs.length) {
      let jobs = Array.from(this.props.jobs);
      if (this.state.printable) {
        jobs = jobs.filter(
          (job) =>
            this.props.realtimesheet.findIndex(
              (entry) => entry.workordernumber === job.assigned_task
            ) > -1
        );
      }

      return jobs.map((job) => {
        let wod = this.props.wods.find(
          (wod) => wod.workOrderNbr === job.assigned_task
        );
        if (
          !wod.dateClosed ||
          moment().isBefore(moment(wod.dateClosed), "day")
        ) {
          return (
            <Table.Row>
              <Table.Cell id="wodCell">
                <div id="woNum"> {job.assigned_task}</div>
                <div id="woddesc">{wod.description}</div>
              </Table.Cell>
              {this.gentimecells(job, dates)}
              <Table.Cell>{this.genTotalJob(job)}</Table.Cell>
            </Table.Row>
          );
        }
      });
    }
  }
  genMoveTimeDatePicker() {
    if (this.props.movetime) {
      return (
        <Grid.Column width={4}>
          <Input
            type="date"
            label="Jump To Date"
            value={this.props.dates[0]}
            onChange={(e) => this.props.handleDateSelect(e.target.value)}
            fluid
          />
        </Grid.Column>
      );
    }
  }
  genadminRow() {
    var ot_emp = this.props.employees.find(
      (e) => e.empnumber === this.props.myinfo.overtime_empnumber
    );
    if (
      (this.props.myinfo.lsadmin || this.props.myinfo.hradmin || ot_emp) &&
      !this.props.mobile &&
      !this.state.printable
    ) {
      let empoptions = [];
      if (this.props.myinfo.hradmin || this.props.myinfo.lsadmin) {
        empoptions = this.props.employees.map((emp) => {
          return {
            key: emp.empnumber,
            text: emp.firstname + " " + emp.lastname,
            value: emp.empnumber,
          };
        });
      } else if (ot_emp) {
        empoptions = [this.props.myinfo, ot_emp].map((emp) => {
          return {
            key: emp.empnumber,
            text: emp.firstname + " " + emp.lastname,
            value: emp.empnumber,
          };
        });
      }

      var empnumber = this.props.empnumber
        ? this.props.empnumber
        : this.props.myinfo.empnumber;

      var toggleText = this.props.weekLocked ? "Week Locked" : "Lock Week"
      return (
        <Grid.Row>
          <Grid.Column width={4}>
            <Dropdown
              search
              fluid
              selection
              options={empoptions}
              value={empnumber}
              onChange={(e, { value }) => this.props.changeemployee(value)}
            />
          </Grid.Column>
          {this.genLockToggle(toggleText)}
          {this.genMoveTimeDatePicker()}
        </Grid.Row>
      );
    }
  }
  genLockToggle(toggleText) {
    if (this.props.myinfo.hradmin || this.props.myinfo.lsadmin) {
      return (
        <Grid.Column width={4}>
          <Checkbox toggle checked={this.props.weekLocked} onChange={() => {
            if (this.props.weekLocked) {
              this.props.unlockWeek();
            } else {
              this.props.lockWeek();
            }
          }

          } label={toggleText} />
        </Grid.Column>
      )
    }
  }
  gendefaulthours(job, date) {
    let hours = this.props.realtimesheet.map((entry) => {
      if (
        entry.workordernumber == job.assigned_task &&
        entry.dateperformed == date
      ) {
        return entry.hours;
      } else {
        return null;
      }
    });

    let hourtotal = hours.reduce((a, b) => a + b, 0);
    //console.log(hourtotal, this.props.date, this.props.job.assigned_task);
    if (hourtotal > 0) {
      return hourtotal;
    } else {
      return "";
    }
  }
  handleentry(job, date) {
    let laborentry = this.props.realtimesheet.find(
      (entry) =>
        entry.dateperformed === date &&
        entry.workordernumber === job.assigned_task
    );
    //console.log(date);
    if (laborentry) {
      return laborentry;
    } else {
      return {
        workordernumber: job.assigned_task,
        description: job.workorder.description,
        empname:
          this.props.employee.firstname + "," + this.props.employee.lastname,
        empnumber: job.empnumber,
        entrytype: "0",
        payrate: job.assignedrate.toString(),
        hours: null,
        dateperformed: date,
        tmind: 0,
        paidcomments: "",
        wedate: moment(date)
          .endOf("isoWeek")
          .format("YYYY-MM-DD"),
        assignedrate: job.assignedrate.toFixed(4),
      };
    }
  }
  gentimecells(job, dates) {
    var readonly =
      this.props.tnms.findIndex(
        (tnm) =>
          tnm.workordernumber === job.assigned_task && tnm.wedate === dates[6]
      ) > -1 || this.props.weekLocked;

    return dates.map((date) => {
      date = moment(date).format("YYYY-MM-DD");
      let laborentry = this.handleentry(job, date);
      return (
        <Table.Cell
          id="timeCell"
          textAlign={this.state.printable || readonly ? "center" : "left"}
        >
          {this.timeinput(job, date, laborentry, readonly)}
        </Table.Cell>
      );
    });
  }
  genptorows() {
    if (
      this.props.ptoinfo &&
      this.props.ptoinfo !== "none" &&
      !this.props.employee.userid.includes("OT") &&
      !this.props.mobile
    ) {
      console.log('EMPLoyee', this.props.employee)
      return (
        <Table.Body>
          <Table.Row>
            <Table.HeaderCell> PTO Totals</Table.HeaderCell>
            <Table.HeaderCell>{"Total Hours"}</Table.HeaderCell>
            <Table.HeaderCell>{"PTO Used"}</Table.HeaderCell>
            <Table.HeaderCell>{"Last Year Balance "}</Table.HeaderCell>
            <Table.HeaderCell>{"PTO Accrued "}</Table.HeaderCell>
            <Table.HeaderCell>{"PTO Balace"}</Table.HeaderCell>
          </Table.Row>
          <Table.Row>
            <Table.Cell />
            <Table.Cell>{this.props.ptoinfo.totalhours}</Table.Cell>
            <Table.Cell>{`${roundy(
              this.props.ptoinfo.ptoused,
              false
            )} hrs`}</Table.Cell>
            <Table.Cell>{this.props.ptoinfo.ptocarryover}</Table.Cell>
            <Table.Cell>{this.props.ptoinfo.ptoaccrued}</Table.Cell>
            <Table.Cell>{`${roundy(
              this.props.ptoinfo.ptobalance,
              false
            )} hrs`}</Table.Cell>
          </Table.Row>
        </Table.Body>
      );
    }
  }

  timeinput(job, date, laborentry, readonly) {
    return (
      <TimeInput
        timedelete={(Hours, wodnum, Date) =>
          this.props.timedelete(Hours, wodnum, Date)
        }
        printable={this.state.printable}
        newentry={laborentry.id === undefined}
        blackedOut={this.props.blackedOut}
        readonly={this.props.readonly || readonly}
        ref="timeinput"
        movetime={this.props.movetime}
        timeinput={() => this.refs.timeinput.nullify()}
        laborentry={laborentry}
        hours={this.gendefaulthours(job, date)}
        empnumber={this.props.myempnumber}
        date={date}
        job={job}
        timeupdate={(entry) => this.props.timeupdate(entry)}
        handleInputchange={(entry) => this.props.handleInputchange(entry)}
        timepost={(laborentry) => this.props.timepost(laborentry)}
      />
    );
  }
  genconfirmicon() {
    if (this.props.confirmed) {
      return <Icon name="checkmark" inverted circular color="green" />;
    } else {
      return <Icon name="minus" inverted circular color="orange" />;
    }
  }

  genheadercells(dates) {
    let daysofweek = this.state.days;
    if (dates && dates.length) {
      return dates.map((date) => {
        let day = daysofweek[moment(date).isoWeekday() - 1] + " ";
        return (
          <Table.HeaderCell
            id={!this.state.printable ? "headercell" : "headercellprint"}
          >
            {day + moment(date).format("MM/DD")}
          </Table.HeaderCell>
        );
      });
    }
  }
  genNonHours() {
    if (
      this.props.employeeinfo &&
      this.props.employeeinfo.emp_stat === "FT SAL"
    ) {
      let date_list = "";
      let total_hours = 0;
      let business_days = this.props.dates.slice(0, -2);
      let temp_ts = Array.from(this.props.realtimesheet);
      // console.log("date_hours", business_days);

      let date_hours = business_days.map((date, i) => {
        temp_ts = temp_ts.concat({ dateperformed: date, hours: 0 });
        let hours = 0;
        temp_ts
          .filter((ts) => ts.dateperformed === date)
          .forEach((entry) => (hours += entry.hours));
        return { date, hours, date_string: this.state.days[i] };
      });
      date_hours = date_hours.filter((d) => d.hours === 0);
      // console.log("date_hours", date_hours);

      date_hours.forEach(
        (d) => (date_list += moment(d.date).format("dddd MMMM Do YYYY") + " ")
      );
      if (date_hours.length && this.genTotality() < 40) {
        return (
          <Table.Body>
            <Table.Row>
              <Table.HeaderCell />
              <Table.HeaderCell colSpan="7">
                I hereby confirm that I will not receive pay for the following
                dates:
              </Table.HeaderCell>
            </Table.Row>
            <Table.Row>
              <Table.Cell />

              {date_hours.map((dh) => {
                return (
                  <Table.Cell>
                    {moment(dh.date).format("dddd")}{" "}
                    {moment(dh.date).format("MM/DD/YY")}
                  </Table.Cell>
                );
              })}
            </Table.Row>
          </Table.Body>
        );
      }
    }
  }

  genTableHeader(dates) {
    return (
      <Table.Header>
        <Table.Row>
          <Table.HeaderCell id="headercell">Task Name</Table.HeaderCell>
          {this.genheadercells(dates)}
          <Table.HeaderCell id="headercell">Job Total</Table.HeaderCell>
        </Table.Row>
      </Table.Header>
    );
  }
  gentable() {
    var dates;
    if (this.props.mobile) {
      dates = [this.state.date];
    } else if (this.props.dates.length) {
      dates = this.props.dates;
    }
    if (dates && dates.length && this.props.jobs.length) {
      return (
        <Grid.Column width={10}>
          <Swipeable
            onSwipedRight={() => this.handleswipe("minus")}
            onSwipedLeft={() => this.handleswipe("plus")}
          >
            <Table
              celled={this.state.printable || this.props.blackedOut}
              columns={this.props.mobile ? 3 : 8}
            >
              {this.genTableHeader(dates)}
              <Table.Body>
                {this.genRows(dates)}

                <Table.Row>
                  <Table.Cell>Daily Total</Table.Cell>
                  {this.genLastRow(dates)}
                  <Table.Cell textAlign="left">{this.genTotality()}</Table.Cell>
                </Table.Row>
              </Table.Body>
              {this.gentablefooter(this.props.mobile)}
              {this.genNonHours()}
            </Table>
            <Table basic="very">{this.genptorows()}</Table>
          </Swipeable>
        </Grid.Column>
      );
    } else {
      return (
        <h1>
          {this.props.employee
            ? "No workorders assigned"
            : "Loading Time Sheet....."}
        </h1>
      );
    }
  }
  genmaterialentry() {
    if (
      !this.state.printable &&
      this.props.myinfo &&
      this.props.myinfo.jtadmin
    ) {
      return (
        <Table.HeaderCell colSpan="2">
          <Button
            onClick={() => {
              this.props.handlemodal("matentry");
            }}
          >
            <Icon name="shopping cart" /> Material Entry
          </Button>
        </Table.HeaderCell>
      );
    }
  }
  gentablefooter(mobile) {
    if (mobile) {
      return (
        <Table.Footer>
          <Table.Row>
            <Table.HeaderCell colSpan={2}>
              <Button.Group
                widths="3"
                color={this.props.confirmed ? "green" : "orange"}
                size="tiny"
              >
                <Button
                  onClick={() => {
                    this.populatedate(
                      moment(this.state.date).subtract(1, "weeks")
                    );

                    this.handlearrow("subtract");
                  }}
                >
                  <Button.Content>Last Week</Button.Content>
                </Button>
                <Button>{this.genconfirmicon()}</Button>
                <Button
                  onClick={() => {
                    this.populatedate(moment(this.state.date).add(1, "weeks"));
                    this.handlearrow("add");
                  }}
                >
                  <Button.Content>Next Week</Button.Content>
                </Button>
              </Button.Group>
            </Table.HeaderCell>
          </Table.Row>
        </Table.Footer>
      );
    } else {
      return (
        <Table.Row>
          <Table.HeaderCell>
            <Button animated onClick={() => this.handlearrow("subtract")}>
              <Button.Content visible>Previous</Button.Content>
              <Button.Content hidden>
                <Icon name="left arrow" />
              </Button.Content>
            </Button>
          </Table.HeaderCell>

          <Table.HeaderCell textAlign="center" colspan={2}>
            <Button
              icon="print"
              circular
              size="medium"
              toggle
              active={this.state.printable}
              onClick={() =>
                this.setState({ printable: true }, () => {
                  if (this.state.printable) {
                    window.print();
                    setTimeout(() => {
                      this.setState({ printable: false });
                    }, 50);
                  }
                })
              }
            />
          </Table.HeaderCell>

          <Table.HeaderCell textAlign="center" colSpan={2}>
            <h3>{"Total: " + this.genTotality() + " Hrs"}</h3>
          </Table.HeaderCell>
          <Table.HeaderCell textAlign="center">
            {this.genconfirmicon()}
          </Table.HeaderCell>
          {this.genmaterialentry()}
          <Table.HeaderCell textAlign="left">
            <Button animated onClick={() => this.handlearrow("add")}>
              <Button.Content visible>Next</Button.Content>
              <Button.Content hidden>
                <Icon name="right arrow" />
              </Button.Content>
            </Button>
          </Table.HeaderCell>
        </Table.Row>
      );
    }
  }
  genLastRow(dates) {
    return dates.map((date) => {
      return (
        <Table.Cell textAlign="center">{this.genTotalDay(date)}</Table.Cell>
      );
    });
  }
  handleswipe(op) {
    let dayindex = moment(this.state.date).isoWeekday() - 1;
    switch (op) {
      case "minus":
        if (dayindex <= 0) {
          this.handlearrow("subtract");
        }
        this.setState({
          date: moment(this.state.date).subtract(1, "days"),
        });
        break;
      case "plus":
        if (dayindex >= 6) {
          this.handlearrow("add");
        }
        this.setState({
          date: moment(this.state.date).add(1, "days"),
        });

        break;
      default:
    }
  }
  handlearrow(operator) {
    this.setState({ defaultinput: null });

    switch (operator) {
      case "add":
        this.props.getnextweek();

        break;
      case "subtract":
        this.props.getlastweek();
        break;
      default:
    }
  }
  render() {
    return (
      <div
        className="TimeEntryDesktop"
        id={this.state.printable ? "timesheetPrint" : "timetableDesktop"}
      >
        <Grid>
          {this.genadminRow()}

          <Grid.Row>{this.gentable()}</Grid.Row>
        </Grid>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    time: state.time,
    myinfo: state.myinfo.employeeinfo,
  };
}
function matchDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      InitialTime: InitialTime,
      jobassign: jobassign,
      getpath: getpath,
    },
    dispatch
  );
}
export default connect(mapStateToProps, matchDispatchToProps)(TimeEntryDesktop);



// WEBPACK FOOTER //
// ./src/components/shared-components/timesheet/TimeSheet.js